import { List } from 'semantic-ui-react';

import { NAVBAR_HEIGHT } from '../Navbar';
import { styled } from '../Theme';

export const COLLAPSED_SIDEBAR_WIDTH = '58px';
export const EXTENDED_SIDEBAR_WIDTH = '200px';

type SidebarStyleProps = {
  sidebarCollapsed: boolean;
};

export const SidebarStyle = styled.nav<SidebarStyleProps>`
  position: fixed;
  z-index: 100;
  width: ${props => (props.sidebarCollapsed ? COLLAPSED_SIDEBAR_WIDTH : EXTENDED_SIDEBAR_WIDTH)};
  top: ${NAVBAR_HEIGHT};
  bottom: 0;
  left: 0;
  margin-bottom: 0px;
  background: ${props => props.theme.primaryColor};
  transition: width 0.3s, left 0.3s;

  .sidebar__bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const StyledSidebarItem = styled(List.Item)`
  background: ${props => (props.active ? '#6e9bb7' : 'inherit')};
  padding: 0px !important;
  min-width: 100%;
`;
